import { SelectOption } from "@models/ui-models/select-options";
import { Relationship } from "@models/relationships/relationship";
import { IndividualData } from "@models/individuals/individual-data";

export function fromRelationshipToSelectOption(relationship: Relationship): SelectOption<string> {
  const label = relationship?.individualDataOverride
    ? IndividualData.buildFullNameWithMiddleLabel(relationship?.individualDataOverride)
    : relationship?.entityDataOverride!.name;

  return {
    label,
    value: relationship.relationshipId
  };
}

export function fromRelationshipsToSelectOptions(relationships: Relationship[]): SelectOption<string>[] {
  return relationships.map((relationship) => fromRelationshipToSelectOption(relationship));
}
